
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-gray-50 font-poppins">
      <Header />

      {/* Hero Section */}
      <section className="relative h-80 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/96393af4cdb0c0f1fd6ceba3477a9d47.jpg"
            alt="İletişim"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 drop-shadow-2xl">İletişim</h1>
          <p className="text-xl text-gray-100 drop-shadow-md">
            Size nasıl yardımcı olabiliriz?
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 -mt-32 relative z-10 mb-16">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center hover:shadow-2xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-6">
                <i className="ri-phone-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">Telefon</h3>
              <a href="tel:05316036891" className="text-gray-600 hover:text-amber-600 transition-colors cursor-pointer">
                0531 603 68 91
              </a>
              <p className="text-sm text-gray-500 mt-2">Pazartesi - Cumartesi<br />09:00 - 19:00</p>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 text-center hover:shadow-2xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-6">
                <i className="ri-mail-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">E-posta</h3>
              <a href="mailto:info@eminkuyumculuk.com.tr" className="text-gray-600 hover:text-amber-600 transition-colors cursor-pointer break-all">
                info@eminkuyumculuk.com.tr
              </a>
              <p className="text-sm text-gray-500 mt-2">7/24 destek</p>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8 text-center hover:shadow-2xl transition-shadow">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-6">
                <i className="ri-map-pin-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">Adres</h3>
              <p className="text-gray-600 leading-relaxed">
                Kamil Ocak Mah. Divrik Cad. 45/A<br />
                Keçiören / ANKARA
              </p>
            </div>
          </div>

          {/* Contact Form & Map */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Bize Ulaşın</h2>
              <p className="text-gray-600 mb-8">
                Sorularınız, önerileriniz veya özel talepleriniz için formu doldurun, en kısa sürede size dönüş yapalım.
              </p>
              <form className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Adınız
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 text-sm"
                      placeholder="Adınızı girin"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Soyadınız
                    </label>
                    <input
                      type="text"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 text-sm"
                      placeholder="Soyadınızı girin"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta
                  </label>
                  <input
                    type="email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 text-sm"
                    placeholder="ornek@email.com"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon
                  </label>
                  <input
                    type="tel"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 text-sm"
                    placeholder="0500 000 00 00"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Konu
                  </label>
                  <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 text-sm">
                    <option>Ürün Hakkında Bilgi</option>
                    <option>Sipariş Takibi</option>
                    <option>Fiyat Teklifi</option>
                    <option>Şikayet & Öneri</option>
                    <option>Diğer</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Mesajınız
                  </label>
                  <textarea
                    rows={5}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-600 resize-none text-sm"
                    placeholder="Mesajınızı buraya yazın..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-amber-600 text-white py-4 rounded-lg font-semibold hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Mesaj Gönder
                </button>
              </form>
            </div>

            {/* Map & Info */}
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Mağazamızı Ziyaret Edin</h2>
              <p className="text-gray-600 mb-8">
                Ürünlerimizi yakından görmek ve uzman ekibimizle tanışmak için mağazamıza bekleriz.
              </p>

              {/* Map */}
              <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg mb-8">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3058.8!2d32.8!3d39.98!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDU4JzQ4LjAiTiAzMsKwNDgnMDAuMCJF!5e0!3m2!1str!2str!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Emin Kuyumculuk Konum"
                ></iframe>
              </div>

              {/* Additional Info */}
              <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">Çalışma Saatleri</h3>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-medium">Pazartesi - Cuma</span>
                    <span className="text-gray-600">09:00 - 19:00</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-medium">Cumartesi</span>
                    <span className="text-gray-600">09:00 - 19:00</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-medium">Pazar</span>
                    <span className="text-red-600 font-medium">Kapalı</span>
                  </div>
                </div>

                <div className="mt-6 pt-6 border-t border-amber-200">
                  <h4 className="font-semibold text-gray-800 mb-3">Sosyal Medya</h4>
                  <div className="flex gap-3">
                    <a
                      href="#"
                      className="w-10 h-10 flex items-center justify-center bg-white hover:bg-amber-600 hover:text-white rounded-full transition-all cursor-pointer shadow-sm"
                    >
                      <i className="ri-facebook-fill text-lg"></i>
                    </a>
                    <a
                      href="#"
                      className="w-10 h-10 flex items-center justify-center bg-white hover:bg-amber-600 hover:text-white rounded-full transition-all cursor-pointer shadow-sm"
                    >
                      <i className="ri-instagram-line text-lg"></i>
                    </a>
                    <a
                      href="#"
                      className="w-10 h-10 flex items-center justify-center bg-white hover:bg-amber-600 hover:text-white rounded-full transition-all cursor-pointer shadow-sm"
                    >
                      <i className="ri-twitter-x-line text-lg"></i>
                    </a>
                    <a
                      href="#"
                      className="w-10 h-10 flex items-center justify-center bg-white hover:bg-amber-600 hover:text-white rounded-full transition-all cursor-pointer shadow-sm"
                    >
                      <i className="ri-whatsapp-line text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
